import { render, staticRenderFns } from "./202410.vue?vue&type=template&id=7c2baa0c&scoped=true&"
import script from "./202410.vue?vue&type=script&lang=js&"
export * from "./202410.vue?vue&type=script&lang=js&"
import style0 from "./202410.vue?vue&type=style&index=0&id=7c2baa0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2baa0c",
  null
  
)

export default component.exports